// AUTO-GENERATED from the compliance dossier (NL/FR/EN). Public legal pages.
// DRAFT pending lawyer/DPO review before public launch. Last generated 2026-06-30.
export type LegalSection = { heading: string; paragraphs: string[]; bullets?: string[] };
export type LegalContent = { title: string; intro: string; sections: LegalSection[] };
export const legalContent: Record<string, Record<string, LegalContent>> = {
  "privacy": {
    "nl": {
      "title": "Privacybeleid",
      "intro": "Bij Carefunded ondersteunen we je mentaal welzijn. Daarvoor verwerken we persoonsgegevens, soms ook gevoelige gezondheidsgegevens. We vinden het belangrijk dat je begrijpt wat we doen met jouw gegevens, waarom, en welke keuzes je hebt. In dit privacybeleid leggen we dat in heldere taal uit. Dit beleid geldt voor iedereen die ons platform gebruikt: mensen die hulp zoeken, psychologen en organisaties die sessies voor hun medewerkers financieren.",
      "sections": [
        {
          "heading": "Wie is verantwoordelijk en hoe bereik je ons",
          "paragraphs": [
            "Carefunded is een dienst van Praxie Group BV (ondernemingsnummer 0474.564.877, Doornelei 17 bus 103, 2018 Antwerpen). Praxie Group BV is de verwerkingsverantwoordelijke voor de persoonsgegevens die we via het platform verwerken: wij bepalen waarom en hoe die gegevens worden gebruikt.",
            "Heb je een vraag over je privacy of wil je een van je rechten uitoefenen? Mail dan naar privacy@carefunded.be. Voor algemene vragen kun je terecht op support@carefunded.be.",
            "Onze functionaris voor gegevensbescherming (DPO) is Mr. Franklin BV — Olivier Sustronck, bereikbaar via olivier@misterfranklin.be of +32 486 27 53 05. Voor privacyvragen kun je ook terecht op privacy@carefunded.be."
          ]
        },
        {
          "heading": "Welke gegevens we verwerken",
          "paragraphs": [
            "Afhankelijk van hoe je Carefunded gebruikt, verwerken we onder meer de volgende gegevens:"
          ],
          "bullets": [
            "Accountgegevens: je e-mailadres en naam.",
            "Intake- en matchprofiel: de antwoorden uit je korte intake waarmee we je aan een geschikte psycholoog koppelen. Dit omvat GEZONDHEIDSGEGEVENS, zoals het thema waarvoor je hulp zoekt, hoe het met je gaat en eventuele vrije tekst die je zelf invult.",
            "Boekingen en afspraken: welke sessies je plant en bij welke psycholoog.",
            "Betalingsgegevens: gegevens over je betalingen (we zien zelf geen kaartnummers, zie verder).",
            "Cursusvoortgang en journaling: je voortgang in zelfhulpcursussen en je privé reflecties/dagboeknotities.",
            "Professioneel profiel: als je psycholoog bent, de gegevens van je beroepsprofiel.",
            "B2B-gegevens: als je via je werkgever toegang hebt, je lidmaatschap bij die organisatie."
          ]
        },
        {
          "heading": "Waarom we je gegevens gebruiken en op welke rechtsgrond",
          "paragraphs": [
            "We gebruiken je gegevens alleen voor duidelijke doelen, en steeds op basis van een wettelijke grond:"
          ],
          "bullets": [
            "Om je dienst te leveren: je account beheren, je matchen met een psycholoog, sessies plannen en cursussen aanbieden. Grond: uitvoering van onze overeenkomst (Art. 6(1)(b) AVG).",
            "Om je gezondheidsgegevens uit de intake te verwerken: dit doen we op basis van jouw EXPLICIETE TOESTEMMING (Art. 9(2)(a) AVG), die je altijd kunt intrekken.",
            "Voor de zorgverlening door de psycholoog: deze valt onder de uitzondering voor gezondheidszorg (Art. 9(2)(h) AVG).",
            "Voor onze facturatie en boekhouding: dit doen we omdat de wet ons daartoe verplicht (wettelijke verplichting)."
          ]
        },
        {
          "heading": "Expliciete toestemming voor gezondheidsgegevens",
          "paragraphs": [
            "Gezondheidsgegevens zijn extra gevoelig. Daarom verwerken we de gezondheidsgegevens uit je intake alleen nadat je daar uitdrukkelijk toestemming voor hebt gegeven.",
            "Je kunt die toestemming op elk moment intrekken via /mijn-gegevens. Het intrekken heeft geen gevolgen voor verwerkingen die al gebeurd zijn op basis van je eerdere toestemming."
          ]
        },
        {
          "heading": "Met wie we gegevens delen",
          "paragraphs": [
            "We verkopen je gegevens nooit. We delen ze enkel waar dat nodig is om de dienst te laten werken, met partijen die voor ons als verwerker optreden:"
          ],
          "bullets": [
            "Daily.co: voor de versleutelde videogesprekken in je browser. Sessies worden NIET opgenomen.",
            "Stripe: voor de verwerking van betalingen. Wij zien zelf geen kaartnummers.",
            "Microsoft Azure: voor hosting en e-mail, binnen de EU.",
            "MongoDB Atlas: voor onze database, in een EU-regio."
          ]
        },
        {
          "heading": "De psycholoog en je werkgever",
          "paragraphs": [
            "De psycholoog die je zorg verleent, is voor die zorg een zelfstandige verwerkingsverantwoordelijke en is gebonden aan het beroepsgeheim. Carefunded bewaart GEEN klinische inhoud: er worden geen sessienotities bij ons opgeslagen en de videogesprekken worden niet opgenomen. Het klinische dossier wordt door de psycholoog zelf bijgehouden.",
            "Werk je via je werkgever (B2B)? Dan krijgt je werkgever uitsluitend geanonimiseerde, geaggregeerde cijfers te zien, met een drempel van minstens 10 personen (onder die drempel tonen we niets, ook geen aantallen — zie /privacystandaard). Je werkgever krijgt dus nooit identificeerbare gegevens en zeker geen gezondheidsgegevens over jou."
          ]
        },
        {
          "heading": "Doorgifte buiten de Europese Economische Ruimte",
          "paragraphs": [
            "We kiezen waar mogelijk voor verwerking binnen de EU/EER. Als gegevens toch buiten de EER verwerkt worden, zorgen we voor passende waarborgen, zoals de EU-modelcontractbepalingen (Standard Contractual Clauses) of een geldig adequaatheidskader zoals het Data Privacy Framework."
          ]
        },
        {
          "heading": "Hoe lang we je gegevens bewaren",
          "paragraphs": [
            "We bewaren je gegevens niet langer dan nodig:"
          ],
          "bullets": [
            "Vrije tekst uit de intake: maximaal 30 dagen.",
            "Anonieme intakes: maximaal 90 dagen.",
            "Facturen: 7 jaar (wettelijke verplichting).",
            "Accountgegevens: zolang je je account behoudt; je kunt je account zelf verwijderen.",
            "Klinische dossiers: worden door de psycholoog bewaard volgens diens wettelijke verplichtingen."
          ]
        },
        {
          "heading": "Jouw rechten",
          "paragraphs": [
            "Je hebt verschillende rechten over je persoonsgegevens. Veel daarvan kun je zelf direct regelen via /mijn-gegevens:"
          ],
          "bullets": [
            "Inzage en een kopie van je gegevens (self-service export op /mijn-gegevens).",
            "Verwijdering van je gegevens (self-service op /mijn-gegevens).",
            "Verbetering (rectificatie) van onjuiste gegevens.",
            "Bezwaar tegen bepaalde verwerkingen.",
            "Beperking van de verwerking.",
            "Intrekken van je toestemming (op /mijn-gegevens)."
          ]
        },
        {
          "heading": "Een klacht indienen",
          "paragraphs": [
            "We reageren in principe binnen één maand op je verzoek. Ben je niet tevreden over hoe we met je gegevens omgaan? Dan kun je een klacht indienen bij de Gegevensbeschermingsautoriteit (GBA/APD) via gegevensbeschermingsautoriteit.be. We vragen je wel om eerst contact met ons op te nemen via privacy@carefunded.be, zodat we samen naar een oplossing kunnen zoeken."
          ]
        },
        {
          "heading": "Hoe we je gegevens beveiligen",
          "paragraphs": [
            "We nemen je veiligheid serieus. We versleutelen gegevens tijdens het transport en bij opslag (in transit en at rest), passen toegangscontrole toe en bewaren geen klinische inhoud op ons platform.",
            "Concreet betekent dit ook: je videogesprekken worden NIET opgenomen en er worden geen sessienotities bij Carefunded opgeslagen."
          ]
        },
        {
          "heading": "Cookies",
          "paragraphs": [
            "We gebruiken cookies zo minimaal mogelijk; ze zijn vooral functioneel om het platform te laten werken. Meer informatie vind je op /cookies."
          ]
        },
        {
          "heading": "Leeftijd",
          "paragraphs": [
            "Carefunded is bedoeld voor personen van 16 jaar en ouder."
          ]
        },
        {
          "heading": "Geen nooddienst",
          "paragraphs": [
            "Carefunded is geen nooddienst. Ben je in crisis of is er levensgevaar? Bel dan 112. Voor hulp bij zelfmoordgedachten kun je bellen naar de Zelfmoordlijn op 1813 (zelfmoord1813.be). Voor een luisterend oor kun je terecht bij Tele-Onthaal op 106."
          ]
        },
        {
          "heading": "Wijzigingen aan dit privacybeleid",
          "paragraphs": [
            "We kunnen dit privacybeleid van tijd tot tijd aanpassen, bijvoorbeeld bij wijzigingen aan onze dienst of de regelgeving. Bij belangrijke wijzigingen informeren we je. Dit beleid is voor het laatst bijgewerkt op 30 juni 2026."
          ]
        }
      ]
    },
    "fr": {
      "title": "Politique de confidentialité",
      "intro": "Chez Carefunded, nous mettons en relation des personnes avec un psychologue clinicien reconnu pour de la thérapie, du coaching ou de l'auto-assistance accompagnée. Pour cela, nous traitons des données qui vous concernent, parfois des données très sensibles touchant à votre santé. Nous prenons cette responsabilité au sérieux. Cette politique vous explique, dans un langage clair et sans jargon, quelles données nous utilisons, pourquoi, avec qui nous les partageons et quels sont vos droits. Cette version est en vigueur depuis le 30 juin 2026.",
      "sections": [
        {
          "heading": "Qui est responsable et comment nous contacter",
          "paragraphs": [
            "Carefunded est un service de Praxie Group BV (numéro d'entreprise 0474.564.877, Doornelei 17 bus 103, 2018 Anvers). Praxie Group BV est le responsable du traitement de vos données : c'est nous qui déterminons quelles données sont traitées et de quelle manière.",
            "Pour toute question relative à la vie privée ou pour exercer vos droits, vous pouvez nous écrire à privacy@carefunded.be. Pour toute autre question, contactez support@carefunded.be.",
            "Notre délégué à la protection des données (DPO) est Mr. Franklin BV — Olivier Sustronck (olivier@misterfranklin.be, +32 486 27 53 05). Vous pouvez aussi écrire à privacy@carefunded.be."
          ],
          "bullets": [
            "Questions relatives à la vie privée : privacy@carefunded.be",
            "Support général : support@carefunded.be"
          ]
        },
        {
          "heading": "Quelles données nous traitons",
          "paragraphs": [
            "Nous ne collectons que les données nécessaires au bon fonctionnement de notre service. Certaines de ces données concernent votre santé : elles bénéficient d'une protection renforcée."
          ],
          "bullets": [
            "Données de compte : votre adresse e-mail et votre nom.",
            "Intake et profil de mise en relation : il s'agit notamment de DONNÉES DE SANTÉ, comme le thème pour lequel vous cherchez de l'aide, votre bien-être et le texte libre que vous saisissez.",
            "Rendez-vous et réservations.",
            "Paiements (sans jamais voir le numéro de votre carte, voir plus bas).",
            "Progression dans les cours et journaling : vos réflexions personnelles, qui restent privées.",
            "Profil professionnel des psychologues.",
            "Données B2B : votre appartenance à une organisation lorsque votre employeur finance les séances."
          ]
        },
        {
          "heading": "Pourquoi nous traitons vos données et sur quelle base légale",
          "paragraphs": [
            "Nous ne traitons jamais vos données sans raison. Chaque traitement repose sur une base légale prévue par le RGPD."
          ],
          "bullets": [
            "Exécution du contrat (art. 6(1)(b)) : pour vous fournir le service, vous mettre en relation avec un psychologue et gérer vos rendez-vous.",
            "Consentement explicite (art. 9(2)(a)) : pour les données de santé. Vous pouvez retirer ce consentement à tout moment.",
            "Prestation de soins par le psychologue (art. 9(2)(h)) : le psychologue traite vos données dans le cadre des soins, sous le secret professionnel.",
            "Obligation légale (art. 6(1)(c)) : par exemple pour la conservation des factures."
          ]
        },
        {
          "heading": "Consentement explicite pour les données de santé",
          "paragraphs": [
            "Les informations que vous partagez sur votre santé mentale (thème, bien-être, texte libre lors de l'intake) sont des données sensibles. Nous ne les traitons qu'avec votre consentement explicite, que vous donnez activement.",
            "Vous gardez le contrôle : vous pouvez retirer votre consentement à tout moment via la page /mijn-gegevens. Le retrait du consentement n'affecte pas la licéité des traitements déjà effectués avant ce retrait."
          ],
          "bullets": []
        },
        {
          "heading": "Avec qui nous partageons vos données",
          "paragraphs": [
            "Nous ne vendons jamais vos données. Nous ne les partageons qu'avec les partenaires strictement nécessaires au service, qui agissent comme sous-traitants pour notre compte et sont tenus de protéger vos données.",
            "Le psychologue avec qui vous êtes mis en relation est un responsable de traitement indépendant pour les soins qu'il vous prodigue. Il est soumis au secret professionnel. Carefunded ne conserve aucun contenu clinique : aucune note de séance, et les consultations vidéo ne sont pas enregistrées.",
            "Si vos séances sont financées par votre employeur (B2B), celui-ci ne reçoit jamais de données de santé identifiables. Il ne reçoit que des chiffres anonymes et agrégés, et uniquement à partir d'un seuil minimal (≥ 10 personnes ; en dessous, rien n'est affiché — voir /privacystandaard), de sorte que personne ne puisse être identifié."
          ],
          "bullets": [
            "Daily.co : vidéo sécurisée dans le navigateur. Les consultations ne sont PAS enregistrées.",
            "Stripe : traitement des paiements. Nous ne voyons jamais votre numéro de carte.",
            "Microsoft Azure : hébergement et e-mail, dans l'UE.",
            "MongoDB Atlas : base de données, dans une région de l'UE.",
            "Le psychologue : responsable indépendant pour les soins, soumis au secret professionnel.",
            "Votre employeur (B2B) : uniquement des agrégats anonymes (seuil ≥ 10), jamais de données de santé identifiables."
          ]
        },
        {
          "heading": "Transferts en dehors de l'EEE",
          "paragraphs": [
            "Nous privilégions autant que possible un hébergement et un traitement dans l'Union européenne.",
            "Lorsqu'un transfert en dehors de l'Espace économique européen est nécessaire, nous l'encadrons par des garanties appropriées : les clauses contractuelles types de la Commission européenne (SCC) ou le Data Privacy Framework."
          ],
          "bullets": []
        },
        {
          "heading": "Combien de temps nous conservons vos données",
          "paragraphs": [
            "Nous ne conservons vos données que le temps nécessaire."
          ],
          "bullets": [
            "Texte libre de l'intake : maximum 30 jours.",
            "Intakes anonymes : 90 jours.",
            "Factures : 7 ans (obligation légale).",
            "Données de compte : jusqu'à ce que vous supprimiez votre compte.",
            "Dossiers cliniques : conservés par le psychologue, conformément à ses obligations professionnelles."
          ]
        },
        {
          "heading": "Vos droits",
          "paragraphs": [
            "Vous gardez la maîtrise de vos données. La plupart de ces droits peuvent être exercés directement, en libre-service, sur la page /mijn-gegevens.",
            "Nous répondons à vos demandes dans un délai d'un mois maximum.",
            "Si vous estimez que nous ne respectons pas vos droits, vous pouvez introduire une réclamation auprès de l'Autorité de protection des données (APD/GBA), via gegevensbeschermingsautoriteit.be."
          ],
          "bullets": [
            "Accès et copie de vos données (export en libre-service sur /mijn-gegevens).",
            "Suppression de vos données (en libre-service sur /mijn-gegevens).",
            "Rectification de données inexactes.",
            "Opposition à certains traitements.",
            "Limitation du traitement.",
            "Retrait de votre consentement (sur /mijn-gegevens)."
          ]
        },
        {
          "heading": "Sécurité",
          "paragraphs": [
            "Nous protégeons vos données par un chiffrement, tant lors de leur transmission (in transit) que lors de leur stockage (at rest), et par un contrôle strict des accès.",
            "Par conception, nous ne stockons aucun contenu clinique : les consultations vidéo ne sont pas enregistrées et nous ne conservons pas de notes de séance."
          ],
          "bullets": []
        },
        {
          "heading": "Vidéo non enregistrée et absence de notes de séance",
          "paragraphs": [
            "Vos consultations vidéo se déroulent directement dans votre navigateur, de manière chiffrée, et ne sont jamais enregistrées par Carefunded.",
            "Carefunded ne conserve aucune note de séance ni aucun contenu clinique. Ces informations relèvent du psychologue, dans le cadre de son secret professionnel."
          ],
          "bullets": []
        },
        {
          "heading": "Cookies",
          "paragraphs": [
            "Nous utilisons un minimum de cookies, essentiellement des cookies fonctionnels nécessaires au bon fonctionnement de la plateforme.",
            "Vous trouverez plus de détails sur notre page /cookies."
          ],
          "bullets": []
        },
        {
          "heading": "Âge minimum",
          "paragraphs": [
            "Notre service est destiné aux personnes âgées de 16 ans et plus."
          ],
          "bullets": []
        },
        {
          "heading": "Pas de service d'urgence",
          "paragraphs": [
            "Carefunded n'est pas un service d'urgence. En cas de crise ou de danger vital, appelez immédiatement le 112."
          ],
          "bullets": [
            "Urgence vitale : 112",
            "Ligne de prévention du suicide : 1813 (zelfmoord1813.be)",
            "Tele-Onthaal : 106"
          ]
        },
        {
          "heading": "Modifications de cette politique",
          "paragraphs": [
            "Nous pouvons adapter cette politique de confidentialité, par exemple lorsque notre service évolue ou en cas de changement réglementaire. En cas de modification importante, nous vous en informerons.",
            "Cette version est en vigueur depuis le 30 juin 2026."
          ],
          "bullets": []
        }
      ]
    },
    "en": {
      "title": "Privacy Policy",
      "intro": "Carefunded is an online mental-health platform in Belgium. After a short intake, we match you with a recognised clinical psychologist for coaching, therapy or guided self-help, we offer encrypted in-browser video sessions, and we provide self-help courses. Because we work with sensitive information about your wellbeing, we want to be clear about what we do with your data. This policy explains, in plain language, which data we collect, why, with whom we share it, how long we keep it, and what rights you have. It applies to our services in Dutch, French and English.",
      "sections": [
        {
          "heading": "Who is responsible and how to reach us",
          "paragraphs": [
            "Carefunded is a service of Praxie Group BV (company number 0474.564.877, Doornelei 17 bus 103, 2018 Antwerp, Belgium). Praxie Group BV is the data controller for the data described in this policy: we decide why and how your personal data is processed.",
            "For privacy questions or to exercise your rights, contact us at privacy@carefunded.be. For general questions, write to support@carefunded.be.",
            "Our Data Protection Officer (DPO) is Mr. Franklin BV — Olivier Sustronck (olivier@misterfranklin.be, +32 486 27 53 05). You can also reach us at privacy@carefunded.be."
          ]
        },
        {
          "heading": "Which data we process",
          "paragraphs": [
            "Depending on how you use Carefunded, we may process the following categories of personal data:"
          ],
          "bullets": [
            "Account data: your email address and name.",
            "Intake and matching profile: the answers you give during intake so we can match you with the right psychologist. This includes health data such as the theme you want to work on, how you are feeling, and any free text you write.",
            "Bookings and appointments: details of the sessions you schedule.",
            "Payment data: information needed to process your payments (we never see or store your card number — see 'Who we share data with').",
            "Course progress and journaling: your progress in self-help courses and your private reflections (journaling).",
            "Professional profile of psychologists: profile information of the clinical psychologists on our platform.",
            "B2B organisation and membership: if your employer finances your sessions, your membership with that organisation."
          ]
        },
        {
          "heading": "Special note on health data",
          "paragraphs": [
            "Part of the data you share — your intake answers, free text and similar information about your wellbeing — counts as health data, which receives extra protection under the law.",
            "We only process this health data when you give us your explicit consent (Article 9(2)(a) GDPR). You can withdraw that consent at any time via /mijn-gegevens, without affecting the lawfulness of processing that already took place.",
            "Your private journaling and course reflections are yours. We treat them as confidential and use them only to support your experience on the platform."
          ]
        },
        {
          "heading": "Why we process your data and on what legal basis",
          "paragraphs": [
            "We process your data for the following reasons, each with its own legal basis:"
          ],
          "bullets": [
            "To deliver our service — create your account, run the intake, match you with a psychologist, manage bookings and provide courses: performance of our contract with you (Article 6(1)(b) GDPR).",
            "To process the health data in your intake and profile: your explicit consent (Article 9(2)(a) GDPR), which you can withdraw at any time.",
            "For the care provided by the psychologist: the provision of health care by a professional bound by confidentiality (Article 9(2)(h) GDPR).",
            "To meet our legal obligations, for example keeping invoices: legal obligation (Article 6(1)(c) GDPR)."
          ]
        },
        {
          "heading": "Who we share data with",
          "paragraphs": [
            "We do not sell your data. We share it only where needed to run the service, and only with carefully selected partners.",
            "We use the following processors, who act on our instructions:"
          ],
          "bullets": [
            "Daily.co — for the encrypted video sessions. These sessions are NOT recorded.",
            "Stripe — for processing payments. We never see your card number.",
            "Microsoft Azure — for hosting and email, in the EU.",
            "MongoDB Atlas — for our database, in an EU region.",
            "The psychologist who treats you acts as an independent data controller for the care itself, and is bound by professional confidentiality. Carefunded does not store any clinical content (no session notes), and video is never recorded.",
            "If your employer finances your sessions (B2B), the employer only ever receives anonymous, aggregated figures, with a minimum threshold of 10 people (below that threshold we show nothing, not even counts — see /privacystandaard) — never identifiable health data about you."
          ]
        },
        {
          "heading": "Transfers outside the EEA",
          "paragraphs": [
            "We keep your data in the EU/EEA wherever possible. Where a transfer outside the European Economic Area is unavoidable, we rely on appropriate safeguards such as the European Commission's Standard Contractual Clauses (SCCs) or the EU-US Data Privacy Framework, so your data continues to enjoy an adequate level of protection."
          ]
        },
        {
          "heading": "How long we keep your data",
          "paragraphs": [
            "We keep your data no longer than necessary:"
          ],
          "bullets": [
            "Intake free text: up to 30 days.",
            "Anonymous intakes: up to 90 days.",
            "Invoices: 7 years, as required by law.",
            "Account data: until you delete your account.",
            "Clinical records: kept by the psychologist, not by Carefunded."
          ]
        },
        {
          "heading": "Confidentiality of your sessions",
          "paragraphs": [
            "Your video sessions are private. The video is never recorded, and Carefunded does not keep any session notes or other clinical content. Any notes about your care are kept by your psychologist, who is bound by professional confidentiality."
          ]
        },
        {
          "heading": "Your rights",
          "paragraphs": [
            "You have the following rights regarding your personal data:"
          ],
          "bullets": [
            "Access and a copy of your data — available as a self-service export on /mijn-gegevens.",
            "Erasure of your data — available as self-service on /mijn-gegevens.",
            "Rectification of inaccurate data.",
            "Objection to certain processing.",
            "Restriction of processing.",
            "Withdrawal of your consent for health data, at any time, on /mijn-gegevens."
          ]
        },
        {
          "heading": "Contacting us and lodging a complaint",
          "paragraphs": [
            "To exercise any of these rights, use the self-service options on /mijn-gegevens or email privacy@carefunded.be. We will respond within one month at the latest.",
            "If you believe we are not handling your data correctly, you have the right to lodge a complaint with the Belgian Data Protection Authority (Gegevensbeschermingsautoriteit / Autorité de protection des données, GBA/APD) via gegevensbeschermingsautoriteit.be."
          ]
        },
        {
          "heading": "Security",
          "paragraphs": [
            "We protect your data with encryption in transit and at rest, strict access controls, and by simply not storing clinical content. We continuously work to keep your information safe."
          ]
        },
        {
          "heading": "Age",
          "paragraphs": [
            "Our service is intended for people aged 16 and over."
          ]
        },
        {
          "heading": "Cookies",
          "paragraphs": [
            "We use minimal, functional cookies. For more details, see our cookie policy at /cookies."
          ]
        },
        {
          "heading": "Not an emergency service",
          "paragraphs": [
            "Carefunded is not an emergency service. If you are in crisis or your life is in danger, call 112. You can also reach the Suicide Prevention Line on 1813 (zelfmoord1813.be) or Tele-Onthaal on 106."
          ]
        },
        {
          "heading": "Changes to this policy",
          "paragraphs": [
            "We may update this privacy policy from time to time. When we make significant changes, we will let you know. This version is dated 30 June 2026."
          ]
        }
      ]
    }
  },
  "terms": {
    "nl": {
      "title": "Algemene Voorwaarden",
      "intro": "Welkom bij Carefunded. Deze algemene voorwaarden leggen uit wie we zijn, hoe ons platform werkt en welke afspraken er gelden wanneer je gebruikmaakt van onze diensten. Lees ze aandachtig: door een account aan te maken of gebruik te maken van Carefunded ga je akkoord met deze voorwaarden. Bij vragen kan je ons altijd bereiken via support@carefunded.be.",
      "sections": [
        {
          "heading": "Geen nooddienst — bij crisis bel 112",
          "paragraphs": [
            "Carefunded is GEEN nooddienst en is niet bedoeld voor crisis- of noodsituaties. Als je in levensgevaar bent, acuut gevaar loopt of denkt aan zelfdoding, wacht dan niet op een afspraak via ons platform.",
            "Heb je dringend hulp nodig? Neem onmiddellijk contact op via de volgende kanalen, die 24 op 24 bereikbaar zijn:"
          ],
          "bullets": [
            "Bel 112 — het noodnummer voor dringende medische hulp en levensgevaar.",
            "Zelfmoordlijn 1813 — bel 1813 of surf naar zelfmoord1813.be voor gesprekken over zelfdoding.",
            "Tele-Onthaal 106 — bel 106 of chat via hun website voor een luisterend oor in moeilijke momenten."
          ]
        },
        {
          "heading": "Wie we zijn en wat Carefunded doet",
          "paragraphs": [
            "Carefunded is een Belgisch online platform voor geestelijke gezondheid. Wij brengen mensen na een korte intake in contact met een erkende psycholoog of psychotherapeut (aangesloten bij een erkende beroepsvereniging). Sessies verlopen via versleutelde videogesprekken in de browser of, in onderling overleg, in de praktijk van de zorgverlener. Daarnaast bieden we zelfhulpcursussen aan.",
            "Belangrijk: Carefunded is zelf GEEN zorgaanbieder en verleent zelf geen zorg, therapie of medisch advies. De zorg wordt verleend door zelfstandige, erkende klinisch psychologen. Carefunded zorgt voor de matching, de techniek (zoals de videoverbinding), de boeking en de betaling, maar de inhoud van de begeleiding ligt volledig in handen van de psycholoog.",
            "De dienst richt zich op personen die in België verblijven; zorg wordt verleend door in België geregistreerde psychologen naar Belgisch recht.",
            "Carefunded wordt uitgebaat in België. Vragen kan je stellen via support@carefunded.be."
          ]
        },
        {
          "heading": "Identificatie (colofon)",
          "paragraphs": [
            "Carefunded wordt uitgebaat door Praxie Group BV, een besloten vennootschap naar Belgisch recht. De volledige identificatiegegevens (art. III.74 en XII.6 Wetboek van economisch recht):"
          ],
          "bullets": [
            "Onderneming: Praxie Group BV (besloten vennootschap)",
            "Ondernemingsnummer (KBO): 0474.564.877",
            "BTW-nummer: BE 0474.564.877",
            "Rechtspersonenregister: RPR Antwerpen (afdeling Antwerpen)",
            "Zetel: Doornelei 17 bus 103, 2018 Antwerpen, België",
            "E-mail: info@carefunded.be (algemeen contactpunt, ook voor autoriteiten) en support@carefunded.be (gebruikersondersteuning)",
            "Deze algemene voorwaarden zijn steeds raadpleegbaar op /voorwaarden."
          ]
        },
        {
          "heading": "Wie is je contractspartij: psycholoog versus platform",
          "paragraphs": [
            "Wanneer je via Carefunded een sessie boekt, komen er twee aparte overeenkomsten tot stand. De behandelovereenkomst komt tot stand tussen jou (de cliënt) en de psycholoog: een zelfstandige onderneming en beoefenaar van een gereglementeerd zorgberoep. De psycholoog is jouw aanspreekpunt en is aansprakelijk voor de inhoud, de kwaliteit en de veiligheid van de zorg, het klinisch dossier en de naleving van zijn of haar beroepsregels.",
            "Daarnaast sluit je met Praxie Group BV (Carefunded) een overeenkomst voor het gebruik van het platform. Carefunded is de facilitator: wij verzorgen de matching, de boeking, de betaling en de videoverbinding. Voor die platformdiensten — en alleen daarvoor — is Carefunded je aanspreekpunt en aansprakelijk.",
            "Concreet: vragen of klachten over de zórg richt je aan je psycholoog; vragen of klachten over het plátform (boeking, betaling, account, techniek, gegevens) richt je aan Carefunded via support@carefunded.be."
          ]
        },
        {
          "heading": "Meldingen, moderatie en schorsing van profielen",
          "paragraphs": [
            "Carefunded kan een psychologenprofiel weigeren, beperken, schorsen of verwijderen — en waar nodig ook uitbetalingen opschorten — op de volgende gronden: onjuiste of misleidende beroepsgegevens, het verlies of het ontbreken van een vereiste erkenning, visum of lidmaatschap van een beroepsvereniging, ernstige of herhaalde inbreuken op deze voorwaarden of op deontologische regels, onwettige inhoud, fraude of misbruik van het betalingssysteem.",
            "Iedereen kan vermeend onwettige inhoud of een probleem met een profiel bij ons melden via support@carefunded.be. Vermeld daarbij een duidelijke omschrijving van het probleem, de vindplaats (bijvoorbeeld een link) en je contactgegevens, zodat we je melding kunnen behandelen en je op de hoogte kunnen houden.",
            "We behandelen meldingen zorgvuldig, niet-willekeurig en tijdig. Wie door een beslissing wordt getroffen (verwijdering, schorsing of beperking van een profiel, of opschorting van uitbetalingen) ontvangt een gemotiveerde beslissing met vermelding van de grond, en kan daarop reageren via support@carefunded.be. We herzien onze beslissing als daar aanleiding toe is.",
            "Meldingen die stelselmatig en kennelijk ongegrond zijn, kunnen we na waarschuwing tijdelijk buiten behandeling laten."
          ]
        },
        {
          "heading": "Contactpunten",
          "paragraphs": [
            "Voor autoriteiten (waaronder toezichthouders en gerechtelijke instanties) is ons centrale contactpunt info@carefunded.be. Voor gebruikers van het platform is het contactpunt support@carefunded.be.",
            "Je kan met ons communiceren in het Nederlands of het Engels."
          ]
        },
        {
          "heading": "Klachten: over de zorg en over het platform",
          "paragraphs": [
            "Klachten over de zórg (de begeleiding door je psycholoog): bespreek je klacht eerst met je psycholoog zelf. Kom je er samen niet uit, dan kan je terecht bij de Federale ombudsdienst \"Rechten van de patiënt\" via bemiddeling-patientenrechten@health.fgov.be of telefonisch op 02/524 85 20. Voor deontologische klachten over een psycholoog kan je ook terecht bij de Psychologencommissie (compsy.be).",
            "Klachten over het plátform (boeking, betaling, account, techniek, gegevens): mail support@carefunded.be; we bevestigen de ontvangst en zoeken samen naar een oplossing. Raken we er niet uit, dan kan je als consument terecht bij de Consumentenombudsdienst (consumentenombudsdienst.be) en bij het Europese platform voor onlinegeschillenbeslechting (ec.europa.eu/odr)."
          ]
        },
        {
          "heading": "Leeftijd: minimaal 16 jaar",
          "paragraphs": [
            "Om Carefunded te gebruiken moet je minstens 16 jaar oud zijn. Door een account aan te maken bevestig je dat je aan deze leeftijdsvoorwaarde voldoet.",
            "Stellen we vast dat een gebruiker jonger is dan 16 jaar, dan kunnen we het account weigeren of beëindigen."
          ]
        },
        {
          "heading": "Account en verantwoordelijkheden van de gebruiker",
          "paragraphs": [
            "Om gebruik te maken van de begeleiding maak je een account aan. Je bent verantwoordelijk voor de juistheid van de gegevens die je opgeeft en voor het vertrouwelijk houden van je inloggegevens.",
            "Als gebruiker verbind je je ertoe het platform te gebruiken zoals bedoeld en geen misbruik te maken van de diensten."
          ],
          "bullets": [
            "Geef correcte en actuele informatie op bij je registratie en intake.",
            "Houd je wachtwoord geheim en deel je account niet met anderen.",
            "Gebruik het platform respectvol; misbruik, intimidatie of onwettig gedrag tegenover psychologen of medewerkers is niet toegestaan.",
            "Meld ons zo snel mogelijk als je vermoedt dat je account ongeoorloofd gebruikt wordt."
          ]
        },
        {
          "heading": "Sessies: intro, coaching en therapie",
          "paragraphs": [
            "Na je intake matchen we je met een erkende klinisch psycholoog. Afhankelijk van je situatie en voorkeur kan je terecht voor een kennismakings- of introsessie, coaching, therapie of begeleide zelfhulp.",
            "Sessies vinden plaats via een versleutelde videoverbinding in je browser of, als jullie dat samen afspreken, in de praktijk van je psycholoog of psychotherapeut. Videogesprekken worden niet opgenomen. De zorgverlener bepaalt, samen met jou, het verloop, de frequentie en de aanpak van de begeleiding.",
            "Carefunded geeft geen garanties over een specifiek behandelresultaat. De begeleiding is professionele zorg en geen garantie op genezing of een bepaald effect."
          ]
        },
        {
          "heading": "Boeking en annulering",
          "paragraphs": [
            "Je boekt een sessie via het platform op een beschikbaar moment in de agenda van je zorgverlener. Bij een videosessie ontvang je na bevestiging de gegevens om deel te nemen; een sessie in de praktijk vind je op het afgesproken adres.",
            "Wil je een afspraak verzetten of annuleren, doe dit dan tijdig. Annuleer je laattijdig of kom je niet opdagen, dan kan de sessie alsnog (gedeeltelijk) worden aangerekend, volgens de annuleringsvoorwaarden die bij de boeking worden getoond.",
            "Zowel jij als de psycholoog kunnen een afspraak in uitzonderlijke gevallen verzetten; we proberen je dan zo snel mogelijk te informeren en een alternatief aan te bieden."
          ]
        },
        {
          "heading": "Betalingen, terugbetaling en B2B",
          "paragraphs": [
            "Voor individuele gebruikers (B2C) betaal je per sessie. De betaling verloopt via onze betaalpartner Stripe; Carefunded ziet je kaartnummer niet. De geldende tarieven worden duidelijk getoond vóór je bevestigt.",
            "Mogelijk heb je recht op een gedeeltelijke terugbetaling van je ziekenfonds of mutualiteit. Indien van toepassing kunnen we je een attest of bewijs van de sessie tonen of bezorgen, zodat je dit zelf bij je ziekenfonds kan indienen. Carefunded regelt deze terugbetaling niet automatisch en kan geen terugbetaling garanderen — dat hangt af van je ziekenfonds en je persoonlijke situatie.",
            "Voor zakelijke gebruikers (B2B) financiert de werkgever de sessies. In dat geval gelden de afspraken die met je werkgever zijn gemaakt over het aantal en het soort sessies. Je werkgever ontvangt nooit identificeerbare gezondheidsgegevens, enkel anonieme, geaggregeerde cijfers."
          ]
        },
        {
          "heading": "Rol van de psycholoog versus rol van Carefunded",
          "paragraphs": [
            "De begeleiding wordt verleend door een zelfstandige, erkende klinisch psycholoog. Deze psycholoog is een onafhankelijke zorgverlener, gebonden aan het beroepsgeheim en aan de deontologische en wettelijke regels van zijn of haar beroep. De psycholoog is verantwoordelijk voor de inhoud en de kwaliteit van de zorg.",
            "Carefunded faciliteert deze zorg: we zorgen voor de matching, de technische omgeving, de planning en de betaling. Carefunded bewaart geen klinische inhoud — er worden geen sessienotities bijgehouden en video's worden niet opgenomen.",
            "De therapeutische relatie bestaat tussen jou en de psycholoog, niet tussen jou en Carefunded."
          ]
        },
        {
          "heading": "Aansprakelijkheid",
          "paragraphs": [
            "Carefunded stelt alles in het werk om een betrouwbaar en goed werkend platform aan te bieden, maar kan niet aansprakelijk worden gesteld voor de inhoud, de uitkomst of de medische aspecten van de zorg zelf. Die verantwoordelijkheid ligt bij de behandelende psycholoog.",
            "Carefunded is niet aansprakelijk voor onrechtstreekse schade, voor schade door tijdelijke onbeschikbaarheid van het platform of de videoverbinding, of voor schade die voortvloeit uit verkeerd of onwettig gebruik van de diensten.",
            "Niets in deze voorwaarden beperkt aansprakelijkheid die volgens dwingend Belgisch recht niet kan worden uitgesloten, zoals in geval van opzet of zware fout."
          ]
        },
        {
          "heading": "Intellectuele eigendom",
          "paragraphs": [
            "Alle inhoud op het platform — waaronder de software, het ontwerp, de teksten, de zelfhulpcursussen, logo's en merken — is eigendom van Carefunded of haar licentiegevers en is beschermd door intellectuele eigendomsrechten.",
            "Je krijgt een persoonlijk, niet-overdraagbaar recht om het platform en de cursussen te gebruiken voor je eigen begeleiding. Je mag deze inhoud niet kopiëren, verspreiden, publiceren of commercieel gebruiken zonder onze voorafgaande schriftelijke toestemming.",
            "Eigen aantekeningen en reflecties die je zelf in het platform maakt, blijven van jou."
          ]
        },
        {
          "heading": "Beëindiging",
          "paragraphs": [
            "Je kan je gebruik van Carefunded op elk moment stopzetten en je account verwijderen via /mijn-gegevens. Lopende of reeds geboekte sessies blijven onderhevig aan de geldende voorwaarden.",
            "Carefunded kan een account opschorten of beëindigen bij ernstige of herhaalde inbreuken op deze voorwaarden, bij misbruik, of wanneer dit wettelijk vereist is. We brengen je hiervan op de hoogte tenzij dit wettelijk niet is toegestaan.",
            "Bepaalde verplichtingen blijven gelden na beëindiging, zoals de wettelijke bewaring van facturen (7 jaar)."
          ]
        },
        {
          "heading": "Toepasselijk recht en bevoegde rechtbanken",
          "paragraphs": [
            "Op deze algemene voorwaarden en op het gebruik van Carefunded is het Belgisch recht van toepassing.",
            "Geschillen die we niet in onderling overleg kunnen oplossen, worden voorgelegd aan de bevoegde rechtbanken in België. Als consument kan je je daarnaast wenden tot de buitengerechtelijke geschillenregeling, bijvoorbeeld via de Consumentenombudsdienst."
          ]
        },
        {
          "heading": "Wijzigingen aan deze voorwaarden",
          "paragraphs": [
            "We kunnen deze algemene voorwaarden van tijd tot tijd aanpassen, bijvoorbeeld bij nieuwe functies of gewijzigde regelgeving. De meest recente versie vind je steeds op deze pagina.",
            "Bij belangrijke wijzigingen brengen we je hiervan op een gepaste manier op de hoogte. Door het platform te blijven gebruiken na een aanpassing, aanvaard je de bijgewerkte voorwaarden.",
            "Deze voorwaarden werden laatst bijgewerkt op 29 juni 2026."
          ]
        }
      ]
    },
    "fr": {
      "title": "Conditions générales",
      "intro": "Bienvenue sur Carefunded. Les présentes conditions générales régissent l'utilisation de notre plateforme et des services qui y sont proposés. En créant un compte ou en utilisant Carefunded, vous acceptez ces conditions. Nous vous invitons à les lire attentivement. Elles sont rédigées dans un langage aussi clair que possible afin que chacun puisse comprendre ses droits et ses obligations.",
      "sections": [
        {
          "heading": "1. Qui sommes-nous et ce qu'est Carefunded",
          "paragraphs": [
            "Carefunded est une plateforme belge en ligne dédiée à la santé mentale. Après une courte évaluation initiale (intake), nous vous mettons en relation avec un psychologue clinicien agréé pour du coaching, de la thérapie ou de l'auto-assistance accompagnée. La plateforme propose également une vidéo chiffrée directement dans votre navigateur ainsi que des programmes d'auto-assistance.",
            "Point essentiel : Carefunded est un intermédiaire qui met en relation et facilite l'accès aux soins. Carefunded n'est pas un prestataire de soins et ne fournit pas elle-même de soins psychologiques ou médicaux. Les soins sont prodigués par des psychologues cliniciens indépendants et agréés, qui exercent sous leur propre responsabilité professionnelle.",
            "Le service s'adresse aux personnes résidant en Belgique ; les soins sont dispensés par des psychologues enregistrés en Belgique, conformément au droit belge.",
            "Le responsable de la plateforme est Carefunded (Belgique). Pour toute question générale : support@carefunded.be. Pour les questions relatives à la vie privée : privacy@carefunded.be."
          ],
          "bullets": [
            "Nous facilitons la mise en relation, la prise de rendez-vous et le paiement.",
            "Nous proposons une vidéo sécurisée et des cours d'auto-assistance.",
            "Le contenu clinique de l'accompagnement relève exclusivement du psychologue."
          ]
        },
        {
          "heading": "Identification (mentions légales)",
          "paragraphs": [
            "Carefunded est exploité par Praxie Group BV, une société à responsabilité limitée de droit belge (art. III.74 et XII.6 du Code de droit économique) :"
          ],
          "bullets": [
            "Entreprise : Praxie Group BV (société à responsabilité limitée)",
            "Numéro d'entreprise (BCE) : 0474.564.877",
            "Numéro de TVA : BE 0474.564.877",
            "Registre des personnes morales : RPM Anvers (division Anvers)",
            "Siège : Doornelei 17 bus 103, 2018 Anvers, Belgique",
            "E-mail : info@carefunded.be (contact général, aussi pour les autorités) et support@carefunded.be (assistance aux utilisateurs)",
            "Les présentes conditions générales sont consultables à tout moment sur /voorwaarden."
          ]
        },
        {
          "heading": "Qui est votre cocontractant : psychologue ou plateforme",
          "paragraphs": [
            "Lorsque vous réservez une séance via Carefunded, deux contrats distincts se forment. Le contrat de soins est conclu entre vous (le client) et le psychologue, entreprise indépendante et praticien d'une profession de soins réglementée. Le psychologue répond du contenu, de la qualité et de la sécurité des soins, du dossier clinique et du respect de ses règles professionnelles.",
            "Vous concluez par ailleurs avec Praxie Group BV (Carefunded) un contrat d'utilisation de la plateforme. Carefunded est le facilitateur : mise en relation, réservation, paiement et connexion vidéo. Pour ces services de plateforme — et pour ceux-là uniquement — Carefunded est votre interlocuteur et en répond.",
            "Concrètement : pour les soins, adressez-vous à votre psychologue ; pour la plateforme (réservation, paiement, compte, technique, données), adressez-vous à Carefunded via support@carefunded.be."
          ]
        },
        {
          "heading": "Signalements, modération et suspension de profils",
          "paragraphs": [
            "Carefunded peut refuser, restreindre, suspendre ou supprimer un profil de psychologue — et, le cas échéant, suspendre les versements — pour les motifs suivants : données professionnelles inexactes ou trompeuses, perte ou absence d'un agrément, visa ou affiliation professionnelle requis, manquements graves ou répétés aux présentes conditions ou aux règles déontologiques, contenu illicite, fraude ou abus du système de paiement.",
            "Toute personne peut nous signaler un contenu présumé illicite ou un problème lié à un profil via support@carefunded.be, en décrivant clairement le problème et son emplacement (lien).",
            "Nous traitons les signalements avec diligence et de manière non arbitraire. Toute personne visée par une décision (suppression, suspension ou restriction d'un profil, ou suspension des versements) reçoit une décision motivée mentionnant le motif, et peut y répondre via support@carefunded.be.",
            "Les signalements manifestement infondés et répétés peuvent, après avertissement, être temporairement laissés sans suite."
          ]
        },
        {
          "heading": "Points de contact",
          "paragraphs": [
            "Pour les autorités : info@carefunded.be. Pour les utilisateurs de la plateforme : support@carefunded.be.",
            "Vous pouvez communiquer avec nous en néerlandais ou en anglais."
          ]
        },
        {
          "heading": "Plaintes : concernant les soins et concernant la plateforme",
          "paragraphs": [
            "Plaintes concernant les soins (l'accompagnement par votre psychologue) : parlez-en d'abord avec votre psychologue. À défaut de solution, vous pouvez vous adresser au Service de médiation fédéral « Droits du patient » via bemiddeling-patientenrechten@health.fgov.be ou au 02/524 85 20. Pour les plaintes déontologiques concernant un psychologue, vous pouvez aussi vous adresser à la Commission des Psychologues (compsy.be).",
            "Plaintes concernant la plateforme (réservation, paiement, compte, technique, données) : écrivez à support@carefunded.be. À défaut de solution, vous pouvez, en tant que consommateur, vous adresser au Service de médiation pour le consommateur (mediationconsommateur.be) et à la plateforme européenne de règlement en ligne des litiges (ec.europa.eu/odr)."
          ]
        },
        {
          "heading": "2. Pas un service d'urgence",
          "paragraphs": [
            "Carefunded n'est pas un service d'urgence et ne convient pas aux situations de crise ou de danger vital. Notre plateforme ne permet pas une intervention immédiate et ne remplace en aucun cas les services de secours.",
            "Si vous êtes en danger, si vous avez des pensées suicidaires ou si vous craignez pour votre sécurité ou celle d'autrui, n'utilisez pas Carefunded : contactez immédiatement les services adaptés."
          ],
          "bullets": [
            "Urgence ou danger vital : appelez le 112.",
            "Ligne de prévention du suicide (Zelfmoordlijn) : 1813 — zelfmoord1813.be.",
            "Tele-Onthaal (écoute) : 106."
          ]
        },
        {
          "heading": "3. Âge minimum",
          "paragraphs": [
            "Vous devez être âgé d'au moins 16 ans pour créer un compte et utiliser Carefunded. En utilisant la plateforme, vous confirmez avoir au moins 16 ans.",
            "Si nous constatons qu'un compte a été créé par une personne n'ayant pas l'âge requis, nous pouvons le suspendre ou le supprimer."
          ]
        },
        {
          "heading": "4. Compte et responsabilités de l'utilisateur",
          "paragraphs": [
            "Pour utiliser nos services, vous créez un compte avec des informations exactes et à jour. Vous êtes responsable de la confidentialité de vos identifiants et de toute activité réalisée via votre compte.",
            "Vous vous engagez à utiliser la plateforme de manière loyale et respectueuse, et à ne pas porter atteinte à son bon fonctionnement, à sa sécurité ou aux droits d'autrui."
          ],
          "bullets": [
            "Fournir des informations exactes lors de l'inscription et de l'intake.",
            "Garder vos identifiants confidentiels et nous signaler tout usage non autorisé.",
            "Respecter les psychologues, les autres utilisateurs et la plateforme.",
            "Ne pas utiliser Carefunded à des fins illégales ou abusives."
          ]
        },
        {
          "heading": "5. Séances : intro, coaching et thérapie",
          "paragraphs": [
            "Carefunded donne accès à différents types de séances avec un psychologue clinicien agréé : une séance d'introduction (pour faire connaissance et évaluer l'adéquation), des séances de coaching et des séances de thérapie.",
            "La mise en relation se base sur votre intake et sur votre profil de correspondance. Le psychologue détermine, dans le cadre de sa pratique professionnelle, le contenu et l'orientation de l'accompagnement."
          ]
        },
        {
          "heading": "6. Réservation et annulation",
          "paragraphs": [
            "Vous réservez vos séances directement via la plateforme, selon les disponibilités proposées. Une réservation confirmée constitue un engagement à vous présenter à l'heure convenue.",
            "Si vous ne pouvez pas honorer un rendez-vous, annulez-le ou reportez-le dans les délais indiqués lors de la réservation. Une annulation tardive ou une absence peut entraîner la facturation de la séance, conformément aux modalités communiquées au moment de la réservation."
          ],
          "bullets": [
            "Réservez et gérez vos rendez-vous via votre compte.",
            "Annulez à temps pour éviter des frais.",
            "Une absence ou une annulation tardive peut être facturée."
          ]
        },
        {
          "heading": "7. Paiements (B2C et B2B) et attestation de remboursement",
          "paragraphs": [
            "En mode B2C, vous payez vous-même chaque séance. Les paiements sont traités par notre prestataire Stripe ; Carefunded ne voit pas les numéros de carte. Les prix applicables vous sont communiqués avant la confirmation de la réservation.",
            "Sur demande, une attestation peut vous être fournie en vue d'un éventuel remboursement (par exemple auprès de votre mutualité ou assurance). Carefunded se limite à mettre cette attestation à disposition : nous n'automatisons ni ne garantissons aucun remboursement, et les conditions de remboursement dépendent de votre organisme.",
            "En mode B2B, votre employeur finance tout ou partie des séances. L'employeur ne reçoit jamais de données de santé identifiables : il n'a accès qu'à des chiffres agrégés et anonymisés (avec un seuil minimal de dix personnes)."
          ],
          "bullets": [
            "B2C : paiement par séance via Stripe.",
            "Attestation de remboursement fournie sur demande, sans automatisation.",
            "B2B : financement par l'employeur, sans accès aux données de santé individuelles."
          ]
        },
        {
          "heading": "8. Rôle du psychologue et rôle de Carefunded",
          "paragraphs": [
            "Le psychologue clinicien est un professionnel indépendant et agréé. Il agit en tant que responsable de traitement distinct pour les soins qu'il prodigue et est tenu au secret professionnel. Le contenu de l'accompagnement (séances, conseils, suivi clinique) relève de sa seule responsabilité.",
            "Carefunded facilite la mise en relation, la réservation, le paiement et l'accès à la vidéo sécurisée. Carefunded ne conserve aucun contenu clinique : les vidéos ne sont pas enregistrées et nous ne stockons pas de notes de séance."
          ]
        },
        {
          "heading": "9. Limitation de responsabilité",
          "paragraphs": [
            "Carefunded met tout en œuvre pour offrir une plateforme fiable et sécurisée. Toutefois, notre rôle se limite à la mise en relation et à la facilitation technique.",
            "Carefunded n'assume aucune responsabilité médicale ou clinique pour les soins eux-mêmes : ceux-ci sont fournis par le psychologue indépendant, qui en répond seul. Dans les limites autorisées par la loi, la responsabilité de Carefunded se limite au bon fonctionnement de la plateforme et n'est pas engagée pour les dommages indirects.",
            "Rien dans les présentes conditions ne vise à exclure une responsabilité qui ne peut légalement l'être."
          ]
        },
        {
          "heading": "10. Propriété intellectuelle",
          "paragraphs": [
            "La plateforme, son contenu (textes, cours d'auto-assistance, design, logiciels, marques) et tous les droits qui s'y rattachent appartiennent à Carefunded ou à ses partenaires. Une licence personnelle et non transférable vous est accordée pour utiliser la plateforme dans le cadre prévu.",
            "Vous ne pouvez pas copier, distribuer, modifier ou exploiter commercialement nos contenus sans autorisation écrite préalable. Vos réflexions personnelles et vos contenus privés (par exemple votre journal) restent les vôtres."
          ]
        },
        {
          "heading": "11. Résiliation",
          "paragraphs": [
            "Vous pouvez à tout moment cesser d'utiliser Carefunded et supprimer votre compte via votre espace personnel (/mijn-gegevens).",
            "Nous pouvons suspendre ou résilier l'accès en cas de violation des présentes conditions, d'usage abusif ou pour des raisons de sécurité ou légales. Certaines obligations subsistent après la fin de la relation, notamment la conservation des factures pendant la durée légale (sept ans)."
          ]
        },
        {
          "heading": "12. Droit applicable et juridictions compétentes",
          "paragraphs": [
            "Les présentes conditions sont régies par le droit belge. En cas de litige, les tribunaux compétents de Belgique sont seuls compétents, sans préjudice des dispositions impératives en matière de protection des consommateurs.",
            "Vous avez également la possibilité d'introduire une plainte auprès de l'Autorité de protection des données (APD) : gegevensbeschermingsautoriteit.be."
          ]
        },
        {
          "heading": "13. Modifications et date",
          "paragraphs": [
            "Carefunded peut adapter ces conditions générales, par exemple en cas d'évolution de ses services ou de la législation. La version applicable est toujours celle publiée sur la plateforme, avec sa date de mise à jour.",
            "En cas de modification importante, nous vous en informerons de manière appropriée. La poursuite de l'utilisation de la plateforme après l'entrée en vigueur des modifications vaut acceptation de celles-ci.",
            "Dernière mise à jour : 29 juin 2026."
          ]
        }
      ]
    },
    "en": {
      "title": "Terms and Conditions",
      "intro": "These Terms and Conditions explain how Carefunded works and the rules that apply when you use our platform. Carefunded is a Belgian online platform for mental wellbeing. After a short intake, we match you with an independent, recognised clinical psychologist for coaching, therapy or guided self-help, and we facilitate encrypted in-browser video sessions and self-help courses. Carefunded is the platform that matches and facilitates care; Carefunded is not a healthcare provider itself. The actual care is delivered by independent, recognised clinical psychologists who are bound by professional confidentiality. By creating an account or using the platform, you agree to these Terms. Please read them carefully, together with our Privacy Statement and Cookie Statement.",
      "sections": [
        {
          "heading": "No emergency service",
          "paragraphs": [
            "Carefunded is not an emergency service and is not suitable for crisis situations. We cannot provide immediate help and we do not monitor messages, bookings or sessions in real time.",
            "If you are in danger, in a life-threatening situation, or worried that you or someone else may be at risk, do not wait for a session. Get help right away through the services below.",
            "If you experience a crisis between sessions, please use these emergency services rather than the platform."
          ],
          "bullets": [
            "Emergency (life-threatening situations): call 112",
            "Suicide prevention line (Zelfmoordlijn): call 1813 or visit zelfmoord1813.be",
            "Tele-Onthaal (someone to talk to, day and night): call 106"
          ]
        },
        {
          "heading": "Who we are and what Carefunded does",
          "paragraphs": [
            "Carefunded is an online platform based in Belgium that helps people find appropriate mental-health support. We offer a short intake, a matching service, encrypted in-browser video sessions (via our video provider), and self-help courses.",
            "Carefunded's role is to match and facilitate. We connect you with an independent, recognised clinical psychologist and we provide the technical tools that make sessions, bookings and payments possible.",
            "Carefunded is not a healthcare provider and does not provide medical or psychological care itself. The care you receive is delivered solely by the independent psychologist you are matched with.",
            "The service is aimed at people residing in Belgium; care is provided by psychologists registered in Belgium, under Belgian law.",
            "You can contact us at support@carefunded.be for general questions, or at privacy@carefunded.be for privacy matters."
          ],
          "bullets": []
        },
        {
          "heading": "Identification (company details)",
          "paragraphs": [
            "Carefunded is operated by Praxie Group BV, a private limited company under Belgian law (art. III.74 and XII.6 of the Belgian Code of Economic Law):"
          ],
          "bullets": [
            "Company: Praxie Group BV (private limited company / besloten vennootschap)",
            "Company number (KBO/BCE): 0474.564.877",
            "VAT number: BE 0474.564.877",
            "Register of legal entities: RPR Antwerp (Antwerp division)",
            "Registered office: Doornelei 17 bus 103, 2018 Antwerp, Belgium",
            "Email: info@carefunded.be (general contact point, including for authorities) and support@carefunded.be (user support)",
            "These Terms are available at any time at /voorwaarden."
          ]
        },
        {
          "heading": "Who your contract is with: psychologist vs. platform",
          "paragraphs": [
            "When you book a session through Carefunded, two separate agreements are formed. The treatment agreement is between you (the client) and the psychologist — an independent business and practitioner of a regulated healthcare profession. The psychologist is answerable for the content, quality and safety of the care, the clinical record, and compliance with their professional rules.",
            "In addition, you enter into an agreement with Praxie Group BV (Carefunded) for the use of the platform. Carefunded is the facilitator: matching, booking, payment and the video connection. For those platform services — and only those — Carefunded is your point of contact and answerable.",
            "In practice: questions or complaints about the care go to your psychologist; questions or complaints about the platform (booking, payment, account, technology, data) go to Carefunded via support@carefunded.be."
          ],
          "bullets": []
        },
        {
          "heading": "Reports, moderation and suspension of profiles",
          "paragraphs": [
            "Carefunded may refuse, restrict, suspend or remove a psychologist profile — and where necessary suspend payouts — on the following grounds: inaccurate or misleading professional information, loss or absence of a required recognition, visa or professional-association membership, serious or repeated breaches of these Terms or of professional-ethics rules, illegal content, fraud, or abuse of the payment system.",
            "Anyone can report allegedly illegal content or a problem with a profile via support@carefunded.be, with a clear description of the issue and its location (link).",
            "We handle reports diligently, non-arbitrarily and in a timely manner. Anyone affected by a decision (removal, suspension or restriction of a profile, or suspension of payouts) receives a reasoned decision stating the ground, and can respond via support@carefunded.be.",
            "Reports that are repeatedly and manifestly unfounded may, after a warning, temporarily be left unprocessed."
          ],
          "bullets": []
        },
        {
          "heading": "Points of contact",
          "paragraphs": [
            "For authorities: info@carefunded.be. For users of the platform: support@carefunded.be.",
            "You can communicate with us in Dutch or English."
          ],
          "bullets": []
        },
        {
          "heading": "Complaints: about the care and about the platform",
          "paragraphs": [
            "Complaints about the care (the support provided by your psychologist): raise them with your psychologist first. If you cannot resolve it together, you can contact the Belgian Federal Ombudsservice \"Rights of the Patient\" via bemiddeling-patientenrechten@health.fgov.be or by phone on 02/524 85 20. For professional-ethics complaints about a psychologist you can also contact the Psychologists Commission (compsy.be).",
            "Complaints about the platform (booking, payment, account, technology, data): email support@carefunded.be. If we cannot resolve it, you can as a consumer turn to the Belgian Consumer Mediation Service (consumerombudsman.be) and the European Online Dispute Resolution platform (ec.europa.eu/odr)."
          ],
          "bullets": []
        },
        {
          "heading": "Age requirement (16+)",
          "paragraphs": [
            "You must be at least 16 years old to create an account and use Carefunded. By using the platform, you confirm that you meet this age requirement.",
            "If we learn that an account has been created by someone under 16, we may suspend or remove that account."
          ],
          "bullets": []
        },
        {
          "heading": "Your account and responsibilities",
          "paragraphs": [
            "To use most of our services you need an account. You agree to provide accurate information and to keep your account details up to date.",
            "You are responsible for keeping your login credentials confidential and for all activity that takes place under your account. Please contact us immediately if you suspect unauthorised use.",
            "You agree to use the platform lawfully and respectfully, not to misuse it, and not to attempt to disrupt, reverse-engineer or gain unauthorised access to our systems or to other users' data."
          ],
          "bullets": []
        },
        {
          "heading": "Sessions, booking and cancellation",
          "paragraphs": [
            "Through the platform you can book different types of sessions, such as an introductory session, coaching, therapy or guided self-help. The type and content of care are determined together with your psychologist.",
            "You book sessions through your account. Please make sure your device, camera and internet connection are working before a video session, as sessions take place in your browser.",
            "If you need to cancel or reschedule, please do so as early as possible and in line with the cancellation rules and notice period shown at the time of booking. Late cancellations or missed appointments may still be charged, as communicated during booking.",
            "Psychologists may also need to reschedule in exceptional circumstances; in that case you will be offered a new time or, where applicable, a refund for that session."
          ],
          "bullets": []
        },
        {
          "heading": "Payments, reimbursement and B2B financing",
          "paragraphs": [
            "For individual (B2C) use, you pay per session. Prices and any applicable cancellation charges are shown before you confirm a booking. Payments are processed through our payment provider; Carefunded does not see or store your full card details.",
            "Where applicable, we can make a reimbursement certificate (attest) available for you to submit to your health insurer. Carefunded only provides this document for you to show to your insurer; we do not arrange or guarantee reimbursement, and any reimbursement depends entirely on your insurer's rules.",
            "For business (B2B) use, your employer may finance your sessions through an organisation membership. In that case the sessions covered by the arrangement are billed to your employer rather than to you. Your employer only receives anonymised, aggregated figures and never identifiable health data.",
            "Invoices are issued in accordance with applicable law. Statutory retention periods apply to invoicing data."
          ],
          "bullets": []
        },
        {
          "heading": "Role of the psychologist vs. role of Carefunded",
          "paragraphs": [
            "The psychologists on the platform are independent professionals. They are solely responsible for the care they provide, for clinical decisions, and for compliance with their professional and ethical obligations, including professional confidentiality (beroepsgeheim).",
            "For the care itself, the psychologist acts as an independent data controller. Carefunded does not store clinical content: video sessions are not recorded and we do not keep session notes.",
            "Carefunded's responsibility is limited to facilitating the platform: matching, scheduling, the technical video connection, payments and self-help materials. The therapeutic relationship is between you and your psychologist."
          ],
          "bullets": []
        },
        {
          "heading": "Limitation of liability",
          "paragraphs": [
            "Carefunded provides the platform with reasonable care, but we do not guarantee that it will always be uninterrupted or error-free.",
            "Because Carefunded facilitates care but does not provide it, Carefunded accepts no medical or clinical liability for the care delivered by the psychologists. Responsibility for the content and quality of the care lies with the independent psychologist.",
            "To the extent permitted by law, Carefunded is not liable for indirect or consequential damage. Nothing in these Terms excludes or limits liability that cannot lawfully be excluded or limited.",
            "Carefunded is not a substitute for emergency or urgent care. Please re-read the section 'No emergency service' above."
          ],
          "bullets": []
        },
        {
          "heading": "Intellectual property",
          "paragraphs": [
            "All content on the platform, including the self-help courses, texts, designs, logos and software, is owned by Carefunded or its licensors and is protected by intellectual property rights.",
            "You may use this content only for your own personal use of the service. You may not copy, distribute, modify or commercially exploit it without our prior written permission.",
            "Any private content you create yourself, such as personal journaling and reflections, remains yours."
          ],
          "bullets": []
        },
        {
          "heading": "Termination",
          "paragraphs": [
            "You can stop using Carefunded at any time and delete your account through your account settings.",
            "We may suspend or terminate access if you breach these Terms, misuse the platform, or where required by law. Where reasonable and lawful, we will let you know.",
            "Some obligations, such as statutory retention of invoicing data, continue to apply after your account is closed, as described in our Privacy Statement."
          ],
          "bullets": []
        },
        {
          "heading": "Governing law and competent courts",
          "paragraphs": [
            "These Terms are governed by Belgian law.",
            "Any disputes that cannot be resolved amicably will be submitted to the competent courts in Belgium. Mandatory consumer-protection rules that grant you additional rights remain unaffected."
          ],
          "bullets": []
        },
        {
          "heading": "Changes to these Terms",
          "paragraphs": [
            "We may update these Terms from time to time, for example to reflect changes to our services or legal requirements. The most recent version is always available on the platform.",
            "If we make significant changes, we will inform you in an appropriate way. By continuing to use the platform after changes take effect, you accept the updated Terms.",
            "Last updated: 29 June 2026."
          ],
          "bullets": []
        }
      ]
    }
  },
  "subprocessors": {
    "nl": {
      "title": "Lijst van sub-verwerkers",
      "intro": "Om ons platform te laten werken, doen we een beroep op een aantal externe dienstverleners. Deze partijen verwerken in onze opdracht (als verwerkers) bepaalde persoonsgegevens, telkens volgens onze instructies en onder een verwerkersovereenkomst. Hieronder vind je een overzicht van wie het zijn, waarvoor we hen inzetten, waar je gegevens worden verwerkt en welke waarborgen gelden bij een eventuele doorgifte buiten de Europese Economische Ruimte (EER). Deze lijst is bijgewerkt op 30 juni 2026.",
      "sections": [
        {
          "heading": "Daily.co",
          "paragraphs": [
            "Doel: Daily.co levert de versleutelde videoverbinding waarmee je je sessie met de psycholoog in je browser voert. De videogesprekken worden niet opgenomen en de inhoud ervan wordt niet bij ons of bij Daily.co bewaard.",
            "Locatie en doorgiftemechanisme: Daily.co is een Amerikaans bedrijf. Omdat je gesprekken niet worden opgenomen of opgeslagen, verwerkt Daily.co enkel de live verbinding tijdens je sessie. Voor de gegevensstromen naar de Verenigde Staten gelden de standaardcontractbepalingen (SCC's) van de Europese Commissie als waarborg."
          ]
        },
        {
          "heading": "Stripe",
          "paragraphs": [
            "Doel: Stripe verwerkt de betalingen op het platform (bijvoorbeeld de betaling per sessie). De volledige kaartgegevens worden rechtstreeks door Stripe verwerkt; wij zien of bewaren zelf geen kaartnummers.",
            "Locatie en doorgiftemechanisme: De betalingsdiensten lopen via de Europese entiteit van Stripe in Ierland. Waar gegevens naar de Verenigde Staten worden doorgegeven, gebeurt dit op basis van de standaardcontractbepalingen (SCC's) en het EU-VS Data Privacy Framework (DPF)."
          ]
        },
        {
          "heading": "Microsoft Azure",
          "paragraphs": [
            "Doel: Microsoft Azure verzorgt de hosting van ons platform en de verzending van onze e-mails (zoals bevestigingen en meldingen).",
            "Locatie en doorgiftemechanisme: De hosting en e-maildiensten draaien in de Europese Unie (Azure-regio Noord-Europa, Ierland), zodat de verwerking binnen de Europese Economische Ruimte plaatsvindt."
          ]
        },
        {
          "heading": "MongoDB Atlas",
          "paragraphs": [
            "Doel: MongoDB Atlas is de databank waarin wij de gegevens van het platform opslaan, zoals je account, intakegegevens, boekingen en cursusvoortgang.",
            "Locatie en doorgiftemechanisme: De databank wordt gehost in de Europese Unie (Azure-regio Noord-Europa, Ierland). Voor eventuele beheersgerelateerde gegevensstromen buiten de EER gelden de standaardcontractbepalingen (SCC's) als waarborg."
          ]
        },
        {
          "heading": "Agendasynchronisatie (Google Calendar en Microsoft Outlook)",
          "paragraphs": [
            "Doel: Als je je Google Calendar of Microsoft (Outlook) agenda koppelt, verschijnen je Carefunded-afspraken automatisch in je eigen agenda en houden we rekening met je beschikbaarheid. Deze koppeling is optioneel en gebeurt alleen wanneer je ze zelf activeert.",
            "Locatie en doorgiftemechanisme: Google en Microsoft verwerken hierbij enkel de gegevens die nodig zijn om je agenda te synchroniseren (zoals het tijdstip en de titel van de afspraak), onder hun verwerkersovereenkomst. Voor eventuele doorgifte naar de Verenigde Staten gelden de standaardcontractbepalingen (SCC's)."
          ]
        },
        {
          "heading": "Wijzigingen en contact",
          "paragraphs": [
            "Wanneer we een sub-verwerker toevoegen, vervangen of verwijderen, passen we deze lijst aan en wijzigen we de datum bovenaan. Bij belangrijke wijzigingen die jou raken, informeren we je via de gebruikelijke kanalen (bijvoorbeeld per e-mail of via een melding op het platform), zodat je tijdig op de hoogte bent en eventueel bezwaar kan maken.",
            "Heb je vragen over deze sub-verwerkers of over de manier waarop we met je gegevens omgaan? Neem dan contact op via privacy@carefunded.be."
          ]
        }
      ]
    },
    "fr": {
      "title": "Liste des sous-traitants",
      "intro": "Pour fournir nos services, Carefunded fait appel à un nombre limité de prestataires externes qui traitent des données personnelles en notre nom. Cette page publique présente ces sous-traitants ainsi que la finalité, la localisation et le mécanisme de transfert applicable à chacun d'eux. Nous sélectionnons nos prestataires avec soin et concluons avec eux des accords de traitement des données conformes au RGPD. Dernière mise à jour : 30 juin 2026.",
      "sections": [
        {
          "heading": "Daily.co",
          "paragraphs": [
            "Finalité : Daily.co fournit la technologie de vidéoconsultation chiffrée que vous utilisez directement dans votre navigateur pour vos séances avec un psychologue.",
            "Aucune séance n'est enregistrée : ni l'image, ni le son ne sont conservés. Daily.co assure uniquement la transmission en temps réel du flux vidéo et audio.",
            "Localisation et transfert : Daily.co est une entreprise établie aux États-Unis. Comme les séances ne sont ni enregistrées ni conservées, Daily.co ne traite que la connexion en direct pendant votre séance. Les transferts éventuels vers les États-Unis sont encadrés par les clauses contractuelles types (CCT) de la Commission européenne."
          ]
        },
        {
          "heading": "Stripe",
          "paragraphs": [
            "Finalité : Stripe traite les paiements (paiement par séance pour les particuliers et facturation pour les organisations B2B) en toute sécurité.",
            "Nous ne voyons jamais vos numéros de carte : ces données sont traitées directement par Stripe et ne transitent pas par nos systèmes.",
            "Localisation et transfert : les paiements des utilisateurs européens sont traités par l'entité européenne de Stripe, établie en Irlande. Lorsque des données sont transférées vers les États-Unis, ces transferts sont encadrés par les clauses contractuelles types (CCT) et le Data Privacy Framework (DPF)."
          ]
        },
        {
          "heading": "Microsoft Azure",
          "paragraphs": [
            "Finalité : Microsoft Azure héberge notre plateforme et assure l'envoi de nos e-mails (par exemple les confirmations de rendez-vous et les notifications de compte).",
            "Localisation et transfert : les données sont hébergées dans des centres de données situés dans l'Union européenne (région Azure Europe du Nord, Irlande). Le traitement a donc lieu au sein de l'EEE."
          ]
        },
        {
          "heading": "MongoDB Atlas",
          "paragraphs": [
            "Finalité : MongoDB Atlas est la base de données dans laquelle sont stockées les données de votre compte et de la plateforme (par exemple votre profil, vos rendez-vous et l'avancement de vos cours).",
            "Localisation et transfert : la base de données est hébergée dans l'Union européenne (région Azure Europe du Nord, Irlande). Les transferts éventuels vers des pays hors EEE sont encadrés par les clauses contractuelles types (CCT)."
          ]
        },
        {
          "heading": "Synchronisation d'agenda (Google Calendar et Microsoft Outlook)",
          "paragraphs": [
            "Finalité : si vous connectez votre agenda Google Calendar ou Microsoft (Outlook), vos rendez-vous Carefunded apparaissent automatiquement dans votre agenda personnel et nous tenons compte de vos disponibilités. Cette connexion est optionnelle et n'a lieu que si vous l'activez vous-même.",
            "Localisation et transfert : Google et Microsoft ne traitent alors que les données nécessaires à la synchronisation (par exemple l'heure et le titre du rendez-vous), dans le cadre de leur accord de traitement. Les transferts éventuels vers les États-Unis sont encadrés par les clauses contractuelles types (CCT)."
          ]
        },
        {
          "heading": "Modifications et contact",
          "paragraphs": [
            "Cette liste peut évoluer si nous ajoutons, remplaçons ou supprimons un sous-traitant. Nous mettons alors à jour cette page et en modifions la date de dernière mise à jour. En cas de changement important, nous vous en informons également de manière appropriée (par exemple par e-mail ou via la plateforme).",
            "Vous avez une question sur nos sous-traitants ou sur le traitement de vos données ? Contactez-nous à l'adresse privacy@carefunded.be."
          ]
        }
      ]
    },
    "en": {
      "title": "Subprocessors",
      "intro": "This page lists the external service providers (subprocessors) that process personal data on behalf of Carefunded when you use our platform. We only work with providers that offer appropriate safeguards for your data, and we keep this list up to date. Wherever possible, data is processed within the European Economic Area (EEA). Where a provider also operates outside the EEA, the transfer is covered by an approved legal mechanism, such as the EU Standard Contractual Clauses (SCCs) or the EU-U.S. Data Privacy Framework (DPF). Last updated: 30 June 2026.",
      "sections": [
        {
          "heading": "Daily.co",
          "paragraphs": [
            "Purpose: Daily.co powers the encrypted, in-browser video sessions between you and your psychologist. It handles the live audio and video connection during your appointment.",
            "No recording: Video and audio sessions are not recorded or stored. The connection exists only for the duration of your live session.",
            "Location and transfer mechanism: Daily.co is a U.S.-based company. Because sessions are neither recorded nor stored, Daily.co only processes the live connection during your appointment. Any transfer of personal data to the United States is covered by the EU Standard Contractual Clauses (SCCs)."
          ]
        },
        {
          "heading": "Stripe",
          "paragraphs": [
            "Purpose: Stripe processes payments for individual sessions and related billing. It securely handles card and payment details so that you can pay safely.",
            "We do not see your card numbers: Card data is entered directly with Stripe. Carefunded never receives or stores your full card number.",
            "Location and transfer mechanism: Payments are handled through Stripe's EU entity in Ireland. Where data is processed in the United States, the transfer is covered by the EU Standard Contractual Clauses (SCCs) and the EU-U.S. Data Privacy Framework (DPF)."
          ]
        },
        {
          "heading": "Microsoft Azure",
          "paragraphs": [
            "Purpose: Microsoft Azure provides the hosting infrastructure for the Carefunded platform and our e-mail delivery. This is where the application runs and where transactional e-mails (such as confirmations and notifications) are sent from.",
            "Location and transfer mechanism: Our Azure resources are hosted in the European Union (Azure North Europe region, Ireland), so this data is processed within the EEA."
          ]
        },
        {
          "heading": "MongoDB Atlas",
          "paragraphs": [
            "Purpose: MongoDB Atlas is the managed database where Carefunded stores platform data such as your account, intake and matching information, bookings, and course progress.",
            "Location and transfer mechanism: Our database runs in the European Union (Azure North Europe region, Ireland). Where any data transfer outside the EEA could occur, it is covered by the EU Standard Contractual Clauses (SCCs)."
          ]
        },
        {
          "heading": "Calendar synchronisation (Google Calendar and Microsoft Outlook)",
          "paragraphs": [
            "Purpose: If you connect your Google Calendar or Microsoft (Outlook) calendar, your Carefunded appointments appear automatically in your own calendar and we take your availability into account. This connection is optional and only happens when you enable it yourself.",
            "Location and transfer mechanism: Google and Microsoft then process only the data needed to synchronise your calendar (such as the time and title of an appointment), under their data processing agreement. Any transfer to the United States is covered by the EU Standard Contractual Clauses (SCCs)."
          ]
        },
        {
          "heading": "Changes to this list",
          "paragraphs": [
            "We may add, replace or remove subprocessors as our services evolve. When we make a material change, we will update this page and adjust the \"last updated\" date above. Where required, we will also inform you directly.",
            "If you have questions about our subprocessors or how your data is handled, please contact us at privacy@carefunded.be."
          ]
        }
      ]
    }
  },
  // Published privacy standard (/privacystandaard). Factual commitments only —
  // every claim here must stay true in code: k>=10 with full suppression (incl.
  // counts), no AI, EU hosting, no third-party tracking, anonymous barometer.
  // Keep in sync with compliance/01-gdpr/barometer-anonimiteit-annex.md and
  // docs/onboarding-kit/.
  "privacystandaard": {
    "nl": {
      "title": "Onze privacystandaard",
      "intro": "Carefunded werkt met gevoelige informatie over mentaal welzijn. Daarom leggen we onszelf een aantal harde regels op — en publiceren we ze, zodat werknemers, werkgevers en hun DPO's ons eraan kunnen houden. Dit is geen marketingtekst: elke regel hieronder is technisch ingebouwd in het platform of contractueel vastgelegd.",
      "sections": [
        {
          "heading": "1. Groepscijfers pas vanaf 10 personen (k≥10) — en daaronder tonen we níéts",
          "paragraphs": [
            "Alles wat een werkgever te zien krijgt, is geaggregeerd: totalen en gemiddelden over groepen. Onze drempel daarvoor is 10 personen. Telt een groep minder dan 10 personen, dan tonen we níéts — ook geen aantallen. Een werkgever kan dus zelfs niet zien dát er een kleine groep is, laat staan wie erin zit.",
            "We onderdrukken ook complementaire cellen: je kunt geen twee overzichten van elkaar aftrekken om alsnog een kleine groep te reconstrueren. Er zijn geen vrije filters of vrij te kiezen periodes waarmee groepen klein gemaakt kunnen worden.",
            "Ter vergelijking: in de markt zijn drempels van 5 of 6 gangbaar, en veel aanbieders publiceren hun drempel helemaal niet. Wij hanteren 10 en leggen dat hier publiek vast."
          ]
        },
        {
          "heading": "2. Wat een werkgever nooit ziet",
          "paragraphs": [
            "Als je werkgever je sessies financiert, blijft je gebruik van Carefunded volledig onzichtbaar voor die werkgever. Concreet ziet je werkgever nooit:"
          ],
          "bullets": [
            "wie zich heeft aangesloten bij de organisatie op het platform;",
            "wie een intake deed, een psycholoog koos, sessies volgt of een zelftest of cursus gebruikt;",
            "individuele antwoorden, scores of gezondheidsgegevens — van niemand;",
            "namen of datums op facturen of exports (die tonen alleen aantallen per type per maand);",
            "wie boven de fair-use cap zit: daarboven schakelt het platform automatisch over op zelf betalen, zonder enige goedkeuringsstap of melding bij de werkgever;",
            "meldingen over individueel gebruik: waarschuwingen aan de werkgever bestaan alleen op het niveau van totale kosten (bijvoorbeeld \"80% van het budget bereikt\"), nooit over personen of kleine groepen."
          ]
        },
        {
          "heading": "3. Geen AI in het product",
          "paragraphs": [
            "Carefunded gebruikt geen artificiële intelligentie. De matching met een psycholoog verloopt via vaste, gepubliceerde regels die je kunt nalezen op /hoe-matchen-wij. Er is geen chatbot, geen AI-analyse van je antwoorden en geen geautomatiseerde besluitvorming met rechtsgevolgen."
          ]
        },
        {
          "heading": "4. Hosting en verwerking in de EU",
          "paragraphs": [
            "Onze servers en database draaien in de Europese Unie (Microsoft Azure en MongoDB Atlas, regio Noord-Europa/Ierland) en videogesprekken worden op EU-infrastructuur gerouteerd. Waar een leverancier ook buiten de EER actief is, dekken we dat af met de EU-modelcontractbepalingen of het Data Privacy Framework. De volledige, actuele lijst van sub-verwerkers vind je op /sub-verwerkers."
          ]
        },
        {
          "heading": "5. Geen tracking of analytics van derden",
          "paragraphs": [
            "We gebruiken geen advertentietrackers en geen analytics-diensten van derden. De cookies die we zetten zijn strikt functioneel (inloggen, betaling, video) — daarom zie je bij ons ook geen cookiebanner. Details staan op /cookies."
          ]
        },
        {
          "heading": "6. De anonieme organisatie-barometer",
          "paragraphs": [
            "Organisaties kunnen periodiek een korte welzijnsbevraging uitsturen (de barometer). Die bestaat uit maximaal drie onderdelen die de werkgever per meting kiest: de wetenschappelijk gevalideerde Cantril-ladder en Burnout Assessment Tool (BAT-12), plus een korte set eigen werkbelevingsvragen van Carefunded (transparant zo gelabeld — geen gevalideerd klinisch instrument en geen klinische screening). De barometer is anoniem door ontwerp, niet door belofte:"
          ],
          "bullets": [
            "iedereen krijgt exact dezelfde link — er is geen login en geen koppeling met je account;",
            "we slaan geen naam, userId, IP-adres of browserkenmerken op, en geen tijdstippen fijner dan de dag;",
            "je krijgt na deelname geen persoonlijke score of label, alleen een neutrale wegwijzer naar hulp;",
            "de werkgever ziet per bevraging alleen groepsgemiddelden vanaf 10 deelnemers — daaronder wordt niets getoond, ook niet hoeveel mensen deelnamen;",
            "er zijn geen team- of afdelingsuitsplitsingen."
          ]
        },
        {
          "heading": "7. Beroepsgeheim en geen klinische inhoud op het platform",
          "paragraphs": [
            "De zorgverlener met wie je praat is een erkende klinisch psycholoog of een psychotherapeut aangesloten bij een erkende beroepsvereniging, gebonden aan het beroepsgeheim. Wat jullie bespreken blijft tussen jullie: videogesprekken worden niet opgenomen en Carefunded bewaart geen sessienotities of andere klinische inhoud. Het klinisch dossier wordt door de psycholoog zelf bijgehouden, buiten ons platform."
          ]
        },
        {
          "heading": "8. Meer weten of ons hieraan houden?",
          "paragraphs": [
            "Het volledige privacybeleid staat op /privacy; je gegevens beheren kan op /mijn-gegevens. Vragen of opmerkingen over deze standaard: privacy@carefunded.be. Onze functionaris voor gegevensbescherming (DPO) is Mr. Franklin BV — Olivier Sustronck (olivier@misterfranklin.be).",
            "Werkgevers aanvaarden contractueel een her-identificatieverbod: elke poging om groepscijfers tot personen te herleiden is een wezenlijke contractbreuk."
          ]
        }
      ]
    },
    "fr": {
      "title": "Notre standard de confidentialité",
      "intro": "Carefunded traite des informations sensibles relatives au bien-être mental. C'est pourquoi nous nous imposons des règles strictes — et nous les publions, afin que les travailleurs, les employeurs et leurs DPO puissent nous demander des comptes. Ceci n'est pas un texte marketing : chaque règle ci-dessous est intégrée techniquement dans la plateforme ou fixée contractuellement.",
      "sections": [
        {
          "heading": "1. Des chiffres de groupe uniquement à partir de 10 personnes (k≥10) — en dessous, nous ne montrons rien",
          "paragraphs": [
            "Tout ce qu'un employeur peut voir est agrégé : des totaux et des moyennes par groupe. Notre seuil est de 10 personnes. Si un groupe compte moins de 10 personnes, nous ne montrons rien — pas même le nombre. Un employeur ne peut donc même pas voir qu'un petit groupe existe.",
            "Nous supprimons également les cellules complémentaires : il est impossible de soustraire deux vues l'une de l'autre pour reconstituer un petit groupe. Il n'existe ni filtres libres ni périodes librement sélectionnables permettant de réduire artificiellement la taille des groupes.",
            "À titre de comparaison : des seuils de 5 ou 6 sont courants sur le marché, et beaucoup de fournisseurs ne publient pas leur seuil du tout. Nous appliquons 10 et le publions ici."
          ]
        },
        {
          "heading": "2. Ce qu'un employeur ne voit jamais",
          "paragraphs": [
            "Si votre employeur finance vos séances, votre utilisation de Carefunded reste totalement invisible pour lui. Concrètement, votre employeur ne voit jamais :"
          ],
          "bullets": [
            "qui s'est affilié à l'organisation sur la plateforme ;",
            "qui a fait un intake, choisi un psychologue, suit des séances ou utilise un auto-test ou un cours ;",
            "des réponses, scores ou données de santé individuels — de personne ;",
            "des noms ou des dates sur les factures ou les exports (uniquement des nombres par type et par mois) ;",
            "qui dépasse le plafond d'utilisation : au-delà, la plateforme bascule automatiquement en paiement personnel, sans aucune étape d'approbation ni notification à l'employeur ;",
            "des alertes sur l'utilisation individuelle : les alertes à l'employeur n'existent qu'au niveau des coûts totaux (par exemple « 80 % du budget atteint »), jamais au niveau de personnes ou de petits groupes."
          ]
        },
        {
          "heading": "3. Pas d'IA dans le produit",
          "paragraphs": [
            "Carefunded n'utilise pas d'intelligence artificielle. La mise en relation avec un psychologue suit des règles fixes et publiées, consultables sur /hoe-matchen-wij. Il n'y a ni chatbot, ni analyse de vos réponses par IA, ni décision automatisée produisant des effets juridiques."
          ]
        },
        {
          "heading": "4. Hébergement et traitement dans l'UE",
          "paragraphs": [
            "Nos serveurs et notre base de données fonctionnent dans l'Union européenne (Microsoft Azure et MongoDB Atlas, région Europe du Nord/Irlande) et les appels vidéo sont routés sur une infrastructure européenne. Lorsqu'un fournisseur opère aussi en dehors de l'EEE, le transfert est couvert par les clauses contractuelles types de l'UE ou le Data Privacy Framework. La liste complète et à jour des sous-traitants se trouve sur /sub-verwerkers."
          ]
        },
        {
          "heading": "5. Pas de tracking ni d'analytics de tiers",
          "paragraphs": [
            "Nous n'utilisons ni traceurs publicitaires ni services d'analytics de tiers. Les cookies que nous déposons sont strictement fonctionnels (connexion, paiement, vidéo) — c'est pourquoi vous ne voyez pas de bannière cookies chez nous. Détails sur /cookies."
          ]
        },
        {
          "heading": "6. Le baromètre d'organisation anonyme",
          "paragraphs": [
            "Les organisations peuvent périodiquement diffuser une courte enquête de bien-être (le baromètre). Elle se compose d'au maximum trois volets que l'employeur choisit pour chaque vague : l'échelle de Cantril et le Burnout Assessment Tool (BAT-12), scientifiquement validés, plus une courte série de questions propres à Carefunded sur le vécu au travail (étiquetées comme telles en toute transparence — ni instrument clinique validé, ni dépistage clinique). Son anonymat tient à sa conception, pas à une promesse :"
          ],
          "bullets": [
            "chacun reçoit exactement le même lien — pas de connexion requise, aucun lien avec votre compte ;",
            "nous n'enregistrons ni nom, ni identifiant, ni adresse IP, ni caractéristiques du navigateur, ni horodatage plus fin que le jour ;",
            "après participation, vous ne recevez ni score personnel ni étiquette, uniquement une orientation neutre vers l'aide disponible ;",
            "l'employeur ne voit, par enquête, que des moyennes de groupe à partir de 10 participants — en dessous, rien n'est affiché, pas même le nombre de participants ;",
            "il n'existe aucune ventilation par équipe ou par département."
          ]
        },
        {
          "heading": "7. Secret professionnel et absence de contenu clinique sur la plateforme",
          "paragraphs": [
            "Le psychologue avec qui vous parlez est un psychologue clinicien agréé, tenu au secret professionnel. Ce que vous vous dites reste entre vous : les appels vidéo ne sont pas enregistrés et Carefunded ne conserve aucune note de séance ni aucun contenu clinique. Le dossier clinique est tenu par le psychologue lui-même, en dehors de notre plateforme."
          ]
        },
        {
          "heading": "8. En savoir plus ou nous demander des comptes ?",
          "paragraphs": [
            "La politique de confidentialité complète se trouve sur /privacy ; vous gérez vos données sur /mijn-gegevens. Questions ou remarques sur ce standard : privacy@carefunded.be. Notre délégué à la protection des données (DPO) est Mr. Franklin BV — Olivier Sustronck (olivier@misterfranklin.be).",
            "Les employeurs acceptent contractuellement une interdiction de ré-identification : toute tentative de relier des chiffres de groupe à des personnes constitue un manquement essentiel au contrat."
          ]
        }
      ]
    },
    "en": {
      "title": "Our privacy standard",
      "intro": "Carefunded works with sensitive information about mental wellbeing. That is why we hold ourselves to a set of hard rules — and publish them, so employees, employers and their DPOs can hold us to them. This is not marketing copy: every rule below is either built into the platform technically or fixed contractually.",
      "sections": [
        {
          "heading": "1. Group figures only from 10 people (k≥10) — below that, we show nothing",
          "paragraphs": [
            "Everything an employer can see is aggregated: totals and averages over groups. Our threshold is 10 people. If a group counts fewer than 10 people, we show nothing — not even the count. An employer cannot even see that a small group exists, let alone who is in it.",
            "We also suppress complementary cells: you cannot subtract two views from each other to reconstruct a small group. There are no free filters or freely selectable time windows that could be used to make groups small.",
            "For comparison: thresholds of 5 or 6 are common in the market, and many providers do not publish their threshold at all. We apply 10 and publish it here."
          ]
        },
        {
          "heading": "2. What an employer never sees",
          "paragraphs": [
            "If your employer finances your sessions, your use of Carefunded remains fully invisible to that employer. Concretely, your employer never sees:"
          ],
          "bullets": [
            "who has joined the organisation on the platform;",
            "who did an intake, chose a psychologist, attends sessions, or uses a self-test or course;",
            "individual answers, scores or health data — of anyone;",
            "names or dates on invoices or exports (these only show counts per type per month);",
            "who exceeds the fair-use cap: above it, the platform automatically switches to self-payment, without any approval step or notification to the employer;",
            "alerts about individual usage: employer alerts exist only at the level of total costs (for example \"80% of budget reached\"), never about individuals or small groups."
          ]
        },
        {
          "heading": "3. No AI in the product",
          "paragraphs": [
            "Carefunded does not use artificial intelligence. Matching with a psychologist follows fixed, published rules that you can read at /hoe-matchen-wij. There is no chatbot, no AI analysis of your answers, and no automated decision-making with legal effects."
          ]
        },
        {
          "heading": "4. Hosting and processing in the EU",
          "paragraphs": [
            "Our servers and database run in the European Union (Microsoft Azure and MongoDB Atlas, North Europe/Ireland region) and video calls are routed on EU infrastructure. Where a provider also operates outside the EEA, the transfer is covered by the EU Standard Contractual Clauses or the Data Privacy Framework. The full, current list of subprocessors is at /sub-verwerkers."
          ]
        },
        {
          "heading": "5. No third-party tracking or analytics",
          "paragraphs": [
            "We use no advertising trackers and no third-party analytics services. The cookies we set are strictly functional (login, payment, video) — which is also why you see no cookie banner here. Details at /cookies."
          ]
        },
        {
          "heading": "6. The anonymous organisation barometer",
          "paragraphs": [
            "Organisations can periodically send out a short wellbeing survey (the barometer). It consists of up to three modules the employer chooses per wave: the scientifically validated Cantril ladder and Burnout Assessment Tool (BAT-12), plus a short set of Carefunded's own work-experience questions (transparently labelled as such — not a validated clinical instrument and not clinical screening). It is anonymous by design, not by promise:"
          ],
          "bullets": [
            "everyone receives exactly the same link — no login, no connection to your account;",
            "we store no name, user ID, IP address or browser characteristics, and no timestamps finer than the day;",
            "after participating you receive no personal score or label, only a neutral signpost to available help;",
            "per survey, the employer only sees group averages from 10 participants onwards — below that, nothing is shown, not even how many people took part;",
            "there are no team or department breakdowns."
          ]
        },
        {
          "heading": "7. Professional confidentiality and no clinical content on the platform",
          "paragraphs": [
            "The psychologist you talk to is a recognised clinical psychologist, bound by professional confidentiality. What you discuss stays between you: video calls are not recorded and Carefunded keeps no session notes or other clinical content. The clinical record is kept by the psychologist, outside our platform."
          ]
        },
        {
          "heading": "8. Want to know more, or hold us to this?",
          "paragraphs": [
            "The full privacy policy is at /privacy; you can manage your data at /mijn-gegevens. Questions or remarks about this standard: privacy@carefunded.be. Our Data Protection Officer (DPO) is Mr. Franklin BV — Olivier Sustronck (olivier@misterfranklin.be).",
            "Employers contractually accept a re-identification ban: any attempt to trace group figures back to individuals is a material breach of contract."
          ]
        }
      ]
    }
  }
};
